export default "__VITE_ASSET__C$dqNdI___"